export default "__VITE_ASSET__CplrtOpf__"